const TokenKey = 'Admin-Token'
const TokenData = 'Admin-Data'
const TokenMsg = 'Admin-Msg'
export function getToken() {
  let time = localStorage.getItem('loginTime') || '0'

  const nowTime = new Date().getTime();
  if((nowTime-60*60*1000)>time || time=='0'){
    removeToken()
  }
  localStorage.setItem('loginTime',new Date().getTime()+'')
  return localStorage.getItem(TokenKey) || null
}

export function setToken(token, data) {
  localStorage.setItem('loginTime', new Date().getTime()+'');
  console.log("到这呢",data)
  localStorage.setItem(TokenData, JSON.stringify(data));
  return localStorage.setItem(TokenKey, token)
}
export function setLoginToken(data) {
  localStorage.setItem(TokenMsg, data);
}

export function removeToken() {
  localStorage.setItem('loginTime', '');
  return localStorage.setItem(TokenKey,'')
}

export function getSession() {
  const user = JSON.parse(localStorage.getItem(TokenKey));
  return user.id;
}



// WEBPACK FOOTER //
// ./src/js/auth.js